import {store} from '../../index';
import {showNotification} from '../../store/app/actions';
import {ErrResp, ErrRespItem} from '../errors/interfaces';
import {isAxiosError} from "~src/utils/isAxiosError";
import {useDispatch} from "react-redux";

export const showApiError = (e: ErrRespItem) => {
  let txtKey = e.translation_key;
  switch (e.translation_key) {
    case 'err_field_required':
      txtKey = `x.error.okr.field_required.${e.arguments.field_name}`;
      break;
    default:
      txtKey = 'x.error.' + txtKey;
  }
  store.dispatch(showNotification({ type: 'error', id: 'errorKey', txtKey, persistent: false }));
};



export const useShowError = (errorId: string, errorTxtKey: string) => {
  const dispatch = useDispatch();

  return (error: Error) => {
    if (isAxiosError(error)) {
      if (error.response) {
        // if it's a standard error response…
        const errResponse = (error.response.data as ErrResp);
        errResponse.forEach((err) => {
          // …and if error has a "real" translation key, use it
          if (err.translation_key.startsWith('x.')) {
            dispatch(
              showNotification({
                id: errorId,
                txtKey: err.translation_key,
                txtProps: err.arguments,
              }),
            );
          } else {
            dispatch(
              showNotification({
                id: errorId,
                txtKey: errorTxtKey,
                txtProps: {error: err.message},
              }),
            );
          }
        });
      } else {
        // if not standard error response, use message if available
        dispatch(
          showNotification({
            id: errorId,
            txtKey: errorTxtKey,
            txtProps: {error: error.message},
          }),
        );
      }
    } else {
      // if not axios error, print message
      dispatch(
        showNotification({
          id: errorId,
          txtKey: errorTxtKey,
          txtProps: {error: error.message}
        }),
      );
    }
  };
};
